
import User from "@/models/user";
import { ref, defineComponent, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { i18n } from "@/i18n";
import { showMessage } from "@/services/MessageService";
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
  setup() {
    const form = ref(User.getRegisterLoginForm());
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const eventData = computed(() => store.getters["user/eventData"]);
    const isEventEnded = ref(false);
    const validForm = computed(() => {
      if (
        form.value.email.value.length &&
        form.value.password.value.length &&
        form.value.passwordConfirm.value.length
      ) {
        return true;
      }
      return false;
    });
    const registerUser = async () => {
      if (form.value.password.value != form.value.passwordConfirm.value) {
        showMessage({
          title: i18n.global.t("login.passwordLabelConfirm"),
          message: i18n.global.t("login.passwordLabelConfirm"),
          type: "warning",
        });
        return;
      }
      const data = {
        email: form.value.email.value,
        password: form.value.password.value,
      };
      await store.dispatch("user/registerUser", data);
      reset();
      router.push({
        name: "UserRegister",
        params: { eventID: route.params.eventID },
      });
    };
    const reset = () => {
      form.value.email.value = "";
      form.value.password.value = "";
      form.value.passwordConfirm.value = "";
    };
    const googleLoginAction = async () => {
      await store.dispatch("user/googleLoginAction", route.params.eventID);
    };
    const facebookLoginAction = async () => {
      await store.dispatch("user/facebookLoginAction", route.params.eventID);
    };
    const goLogin = () => {
      router.push({
        name: "Login",
        params: { eventID: route.params.eventID },
      });
    };
    onMounted(() => {
      if (eventData.value) {
        const endDate = new Date(eventData.value.endDate);
        isEventEnded.value = endDate.getTime() < Date.now();
      }
    });
    return {
      form,
      registerUser,
      googleLoginAction,
      facebookLoginAction,
      goLogin,
      validForm,
      isEventEnded,
    };
  },
});
